<template lang="pug">
div.is-flex.is-align-items-center.is-relative
    .tags.has-addons(v-if="voucherId")
        voucher-name-view.tag.is-black(:value="voucherId")
        a.tag.is-delete(@click="clearVoucher")
    span.tag.is-black.button.is-loading.px-5(v-else-if="submitting" )
    template(v-else)
        a.has-text-weight-semibold(@click="attachVoucher") 
          span.icon
            i.mdi.mdi-gift-outline
          span {{$t('actions.attach_voucher')}}
</template>

<script>
import {mapActions} from 'vuex'
import VoucherRedeem from './VoucherRedeem'
import SALE_ITEM_TYPES from '../../../constants/saleItemTypes'

export default {
  name: 'VoucherInput',
  components: {
    VoucherRedeem
  },
  props: {
    value: {type: String, default: undefined},
    services: {type: Array, default: () => []},
    startDate: {type: Date, default: () => new Date()},
    appointmentId: {type: String, default: undefined}
  },
  data() {
    return {
      voucherId: null,
      submitting: false
    }
  },
  watch: {
    value(val) {
      this.voucherId = val
    }
  },
  created() {
    this.voucherId = this.value
  },
  methods: {
    ...mapActions('appointments', ['setVoucher']),
    async clearVoucher() {
      if (this.voucherId) {
        this.voucherId = undefined
        await this.submit()
      }
    },

    async submit() {
      if (!this.appointmentId) {
        this.$emit('input', this.voucherId)
        return this.$emit('close')
      }
      if (this.submitting) {
        return
      }
      this.submitting = true
      try {
        await this.setVoucher({appointmentId: this.appointmentId, voucherId: this.voucherId})
      } catch (e) {
        this.$handleAPIError(e)
      }
      this.submitting = false
    },
    attachVoucher() {
      this.$buefy.modal.open({
        parent: this.$parent,
        component: VoucherRedeem,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        canCancel: ['outside'],
        props: {
          saleItems: this.services.map(service => ({
            _id: service._id,
            service: service.item.service,
            option: service.item.option,
            type: SALE_ITEM_TYPES.SERVICE
          }))
        },
        events: {
          input: ({voucher}) => {
            this.voucherId = voucher._id
            this.submit()
          }
        }
      })
    }
  }
}
</script>
